import React from 'react'

const DeleteIcon = () => {
    return (
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5996 3.78634C11.2686 3.55534 8.92356 3.43634 6.58555 3.43634C5.19954 3.43634 3.81353 3.50634 2.42752 3.64634L0.999512 3.78634" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.84985 3.07901L5.00385 2.16201C5.11586 1.497 5.19986 1 6.38286 1H8.21687C9.39988 1 9.49088 1.525 9.59588 2.16901L9.74988 3.07901" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.093 5.99797L11.638 13.047C11.561 14.146 11.498 15 9.54498 15H5.05095C3.09793 15 3.03493 14.146 2.95793 13.047L2.50293 5.99797" stroke="#222222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.13184 11.1503H8.46285" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.55005 8.35154H9.05007" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default DeleteIcon